import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useFetchOptions from "./hooks/use-fetch-options.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { vehiclesOptions } = useFetchOptions();

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data/hora inicial *"
                        selected={filters.dtStart ? new Date(filters.dtStart) : null}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data/hora final *"
                        selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <SelectComponent
                        label='Veículos'
                        isMulti={true}
                        wrapValues={true}
                        options={vehiclesOptions}
                        value={filters.vehicles}
                        onChange={(value) => setFilters(prev => ({...prev, vehicles: value}))}
                        instanceId="vehicles"
                        classNameWrapper={"w-full"}
                        isClearable={true}
                    />

                    <div className={"ml-1 mb-2"}>
                        <InputCheckbox
                            id="showOnlyInconsistent"
                            label="Somente com inconsistência"
                            checked={filters.showOnlyInconsistent}
                            onChange={(e) => setFilters(prev => ({...prev, showOnlyInconsistent: e.target.checked}))}
                        />
                    </div>

                    <div className={"ml-1"}>
                        <InputCheckbox
                            id="showGarrison"
                            label="Exibir guarnições"
                            checked={filters.showGarrison}
                            onChange={(e) => setFilters(prev => ({...prev, showGarrison: e.target.checked}))}
                        />
                    </div>

                </form>
            </div>
        </>
    );
};

export default Filters;